export const GET_STUDENT_QUERY = `
  query getStudentUser($userId: String!) {
    getStudentUser(userId: $userId) {
      alpha_learning_level
      is_active
      learning_level
      map_grade_level
      student_id
    }
  }
`;
